import { useQuery } from '@tanstack/react-query';
import { format, subYears } from 'date-fns';

import { getData } from '@/lib/api/client-v2';
import { DATE_ISO } from '@/lib/dates';
import { queryKeys } from '@/lib/query-keys';
import { ENDPOINTS } from '@/types/api/endpoints';
import type { Quittance, TableauPrelevementsResponse } from '@/types/api/payment';

/*
 * Écran « Mes paiements ». Les quittances elles-mêmes sont lues par `use-receipts`
 * (`useReceiptsUnpaid`, `useContractReceipts`).
 */

/* Quittances des 12 derniers mois (date figée au chargement de l'application, comme l'ancien sélecteur). */
const lastYear = format(subYears(new Date(), 1), DATE_ISO);

/** Quittances dont la fin tombe dans les 12 derniers mois (ancien `getReceiptsLastYear`). */
export const getReceiptsLastYear = (receipts: Quittance[] | undefined): Quittance[] =>
    (receipts ?? []).filter((receipt) => receipt.dateFin !== undefined && receipt.dateFin >= lastYear);

/**
 * Tableau de prélèvement d'un contrat (`GET /contracts/{id}/direct-debits`, déléguée à la v1 :
 * le corps v1 arrive dans `data`), relu à chaque montage.
 *
 * Pas de popin à l'échec : l'ancien middleware ne l'interceptait pas.
 */
export const useTableauPrelevements = (contractId: string | number | null | undefined) =>
    useQuery({
        queryKey: queryKeys.contractPrelevements(contractId),
        queryFn: () => getData<TableauPrelevementsResponse>(ENDPOINTS.contractDirectDebits(contractId!)),
        enabled: contractId !== null && contractId !== undefined && contractId !== '',
        refetchOnMount: 'always',
    });
